module.exports = __webpack_public_path__ + "static/img/1-1.a34afa1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/eng/1-1.png
// module id = 0RUp
// module chunks = 0